export default "__VITE_ASSET__db2a7629__"